import React, {useEffect, useRef, useState} from "react";
import {HashRouter, Route, Switch, BrowserRouter} from "react-router-dom";
import "./supply-encoding.css";
import Body from "./Body"
import {AuthContext} from "./auth/AuthContext";
import {
    AUTHENTICATED,
    BUSINESS_ID,
    getLocalStorageItem,
    removeLocalStorageItem,
    ROLE,
    setLocalStorageItem,
    SHOW_MODAL,
    TIME_OUT,
    USER_EMAIL
} from "./utils/storage-utils";
import {roles, UIMapping} from "./utils/roles";
import {useFlags, withLDProvider} from "launchdarkly-react-client-sdk";
import Health from "./Health";

let getLDClientSideID = {
    'localhost':'6050dd85c476650ba41167ab',
    '127.0.0.1':'6050dd85c476650ba41167ab',
    'supplyencodingservice.dev-us1.api.ws-hp.com':'6050dd85c476650ba41167ab',
    'supplyencodingservice.pie-us1.api.ws-hp.com':'6050ddb99a881a0c380e7b94',
    'supplyencodingservice.ext.hp.com': '6050de49c476650ba41167ca',
    'supplyencodingservice.stage-us1.api.ws-hp.com':'6050de3cc476650ba41167c4'
}
let host = window.location.hostname

const App = () => {

   // Declare maintenanceModeEnabledForSynthetics globally
   window.maintenanceModeEnabledForSynthetics = false;

  const [authenticated, setAuthenticated] = useState(getLocalStorageItem(AUTHENTICATED) != null);
  const [role,setRole] =useState(getLocalStorageItem(ROLE) !== null && getLocalStorageItem(ROLE) !== undefined ? getLocalStorageItem(ROLE) : "");
  const [showModal, setShowModal] = useState(getLocalStorageItem(SHOW_MODAL) !== null && getLocalStorageItem(SHOW_MODAL) !== undefined ? getLocalStorageItem(SHOW_MODAL) : true);
  const [businessId,setBusinessId] =useState(getLocalStorageItem(BUSINESS_ID) !== null && getLocalStorageItem(BUSINESS_ID) !== undefined ? getLocalStorageItem(BUSINESS_ID) : "");
  const logoutTime = useRef(null);
  const [userEmail,setUserEmail] = useState(getLocalStorageItem(USER_EMAIL) !== null && getLocalStorageItem(USER_EMAIL) !== undefined ? getLocalStorageItem(USER_EMAIL) : "");
  const {maintenanceMode} = useFlags()

    // Update the global variable when maintenanceMode changes
    useEffect(() => {
      if (maintenanceMode) {
        window.maintenanceModeEnabledForSynthetics = true;
      } else {
        window.maintenanceModeEnabledForSynthetics = false;
      }
      console.log(
        "Global maintenanceModeEnabledForSynthetics:",
        window.maintenanceModeEnabledForSynthetics
      );
    }, [maintenanceMode]);

  const login = (role,businessId,userEmail) => {
    setAuthenticated(true);
    setLocalStorageItem(AUTHENTICATED,true);
    setLocalStorageItem(ROLE,role);
    setRole(role);
    const showModalForAdmin = roles.rmAdministrator === role && showModal === true;
    setShowModal(showModalForAdmin);
    setLocalStorageItem(SHOW_MODAL,showModalForAdmin);
    setLocalStorageItem(BUSINESS_ID,businessId);
    setBusinessId(businessId);
    setLocalStorageItem(USER_EMAIL,userEmail);
    setUserEmail(userEmail);

  }

  const setClicked = (clicked) => {
    setShowModal(clicked);
    setLocalStorageItem(SHOW_MODAL,clicked);
  }

  const logout = () => {
    setAuthenticated(false);
    removeLocalStorageItem(AUTHENTICATED);
    removeLocalStorageItem(ROLE);
    removeLocalStorageItem(SHOW_MODAL);
    setRole("");
    removeLocalStorageItem(BUSINESS_ID);
    setBusinessId("");
    setUserEmail("");
    removeLocalStorageItem(USER_EMAIL);
    removeLocalStorageItem(TIME_OUT);
  }
  const value ={
    authenticated: window.location.port === "3000" ? true : authenticated,
    role: role,
    login: login,
    logout: logout,
    showModal:showModal,
    setClicked:setClicked,
    businessId:businessId,
    userEmail:userEmail,
      uiAccess:UIMapping(role)

  }

  useEffect ( () => {
    const storedUser = getLocalStorageItem(AUTHENTICATED);
    if(storedUser){
        window.addEventListener('load',logoutSession);
        if(!getLocalStorageItem(TIME_OUT) || parseInt(getLocalStorageItem(TIME_OUT),10) > Date.now() ) { 
          const events = ['load','mousemove','mousedown','click', 'scroll','keypress'];
            for( let id in events){
                window.addEventListener(events[id],resetTimeout);
            }
            resetTimeout()
        }
    }
  })

  const resetTimeout = () => {
    setLocalStorageItem(TIME_OUT,Date.now() + 1000*60*60);
    clearTimeout(logoutTime.current)
    timeout()
  }

  const logoutSession = () => {
    if(parseInt(getLocalStorageItem(TIME_OUT),10) < Date.now() ) {
      logout()
      window.location.replace(process.env.REACT_APP_PUBLIC_URL + "/logout");
    }
  }
  const timeout = () => {
    logoutTime.current = setTimeout( ()=> logoutSession(), 1000*60*60);
  }

  return (
    <AuthContext.Provider value={value}>
      <BrowserRouter>
        <Switch>
          <Route path="/accountservice-frontend/health" component={Health} />
          <HashRouter>
            <Switch>
              <Route
                path="/"
                render={() => (
                  <Body
                    maintenanceMode={maintenanceMode}
                    login={login}
                    logout={logout}
                    authenticated={authenticated}
                    role={role}
                    businessId={businessId}
                    showModal={showModal}
                    setClicked={setClicked}
                    userEmail={userEmail}
                  />
                )}
              />
            </Switch>
          </HashRouter>
        </Switch>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
export default withLDProvider({
    clientSideID: getLDClientSideID[host],
})(App);